<script setup lang="ts">
const props = defineProps<{
  company: any
  brandColor: string
  hasReview: boolean
  section?: string
  location?: { city?: string | null, state?: string | null }
  role?: string | null
}>()
const headerStyles = computed(() => ({
  backgroundColor: props.brandColor,
  color: isLightColor(props.brandColor) ? '#000' : '#fff'
}))
</script>

<template>
  <header class="company-header">
    <section
      class="py-8"
      :style="headerStyles"
    >
      <Container>
        <!-- DOM order matches visual order to prevent CLS from order switching -->
        <div class="relative flex flex-col-reverse md:flex-row items-center">
          <CompanyLogo
            :logo-url="company.logo_url"
            :brand-name="company.brand_name"
            class="flex-shrink-0 mt-3 md:mt-0 md:mr-4"
          />
          <CompanyHeaderInfo
            :brand-name="company.brand_name"
            :overall_rating="company.overall_rating"
            :has-review="hasReview"
            :section="section"
            :location="location"
            :role="role"
            :permalink="company.permalink"
            class="text-sm sm:text-base md:text-md min-w-0 flex-shrink w-full md:w-auto mb-4 md:mb-0"
          />
        </div>
      </Container>
    </section>
  </header>
</template>
